export const goToPFHome = (searchId, fareItineraryKey, segmentKeys) => {
  const path = `${searchId}/${fareItineraryKey}/${segmentKeys.join(',')}`;
  window.location.assign(`/travel/price-freeze/#pfhome/${path}/`);
};

export const goToPFPax = (searchId, fareItineraryKey, segmentKeys) => {
  const path = `${searchId}/${fareItineraryKey}/${segmentKeys.join(',')}`;
  window.location.assign(`/travel/price-freeze/#pfpax/${path}/`);
};

export const goToPFPayment = (
  searchId,
  fareItineraryKey,
  segmentKeys,
  shoppingBasketId
) => {
  const path = `${searchId}/${fareItineraryKey}/${segmentKeys.join(
    ','
  )}/${shoppingBasketId}`;
  window.location.assign(`/travel/price-freeze/#pfpayment/${path}/`);
};
